const jsonHeaders = {
  'Content-Type': 'application/json',
};

const handleResponse = async (res) => {
  const text = await res.text();
  let data = null;

  // Try to parse JSON, but do NOT crash if it isn't valid JSON
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  // If the HTTP status is not OK, surface a clean error
  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) ||
      text ||                           // raw body as a last resort
      `Request failed (${res.status})`;

    throw new Error(message);
  }

  return data;
};

export async function apiListMembers() {
  const res = await fetch('/api/members', {
    method: 'GET',
  });
  return handleResponse(res);
}

export async function apiGetMember(id) {
  const res = await fetch(`/api/members/${id}`, {
    method: 'GET',
  });
  return handleResponse(res);
}

export async function apiAddMember(memberData) {
  const res = await fetch('/api/members', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(memberData),
  });
  return handleResponse(res);
}

export async function apiUpdateMember(id, updateData) {
  const res = await fetch(`/api/members/${id}`, {
    method: 'PATCH', // mapped to PUT in the Cloudflare Function
    headers: jsonHeaders,
    body: JSON.stringify(updateData),
  });
  return handleResponse(res);
}

export async function apiArchiveMember(id) {
  const res = await fetch(`/api/members/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify({ is_archived: true }),
  });
  return handleResponse(res);
}

export async function apiRestoreMember(id) {
  const res = await fetch(`/api/members/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify({ is_archived: false }),
  });
  return handleResponse(res);
}

export async function apiUpdateMemberLastSession(id, isoDateString) {
  const res = await fetch(`/api/members/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify({ last_session: isoDateString }),
  });
  return handleResponse(res);
}